interface Point {
  start?: string;
  TeamOneScore: number;
  TeamTwoScore: number;
  GameNumber: number;
}

interface MatchGamePointsProps {
  value1: number;
  value2: number;
  text: string;
  text2: string;
  points1: Point[];
  points2: Point[];
}

function MatchGamePoints({
  value1 = 0,
  value2 = 0,
  text = '',
  text2 = '',
  points1 = [],
  points2 = [],
}: MatchGamePointsProps) {
  return (
    <div className='flex min-h-[110px] flex-wrap border-b py-2 sm:flex-nowrap'>
      <div className='order-2 flex w-1/2 flex-col items-center justify-center p-2 font-bold sm:order-1 sm:w-1/3 sm:p-0'>
        <span>{value1}</span>
        <ul className='flex flex-col gap-1'>
          {points1.map((item, index: number) => (
            <li
              key={item.start + '-team-one-' + index}
              className='flex flex-col items-center justify-center text-xs font-normal'
            >
              <span>
                {item.TeamOneScore} - {item.TeamTwoScore} (G{item.GameNumber})
              </span>
            </li>
          ))}
        </ul>
      </div>
      <div className='order-1 flex w-full flex-col items-center justify-center sm:order-2 sm:w-1/3'>
        <h5 className='font-bold'>{text}</h5>
        <h6>{text2}</h6>
      </div>
      <div className='order-2 flex w-1/2 flex-col items-center justify-center p-2 font-bold sm:order-3 sm:w-1/3 sm:p-0'>
        <span>{value2}</span>
        <ul className='flex flex-col gap-1'>
          {points2.map((item, index: number) => (
            <li
              key={item.start + '-team-two-' + index}
              className='flex flex-col items-center justify-center text-xs font-normal'
            >
              <span>
                {item.TeamOneScore} - {item.TeamTwoScore} (G{item.GameNumber})
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default MatchGamePoints;
